import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function DiagnosisSection() {
  return <section id="diagnostico" className="py-20 md:py-32 bg-cream text-dark" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="max-w-3xl mx-auto" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-19">
            <h2 className="text-3xl md:text-5xl font-heading text-dark mb-6" data-id="element-20">
              ¿Por qué parece que tu cuerpo{' '}
              <span className="text-pink-brand italic" data-id="element-21">"no te obedece"</span>?
            </h2>
          </motion.div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-warm-gray/50 mb-12" data-id="element-22">
            <ul className="space-y-6 mb-10" data-id="element-23">
              {['Has cambiado tu dieta.', 'Has intentado diferentes ejercicios.', 'Quizás ya probaste inositol genérico.'].map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-center text-lg md:text-xl text-gray-700 font-medium" data-id="element-24">
                  <CheckCircle2Icon className="h-6 w-6 text-pink-brand mr-4 flex-shrink-0" data-id="element-25" />
                  {item}
                </motion.li>)}
            </ul>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="text-center" data-id="element-26">
              <p className="text-xl md:text-2xl font-heading text-dark mb-2" data-id="element-27">
                Y aun así:
              </p>
              <p className="text-lg text-gray-600" data-id="element-28">
                El acné persiste, el peso no baja, los antojos de azúcar te
                controlan y tu ciclo es un caos.
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="border-l-4 border-green-brand bg-green-brand/5 p-6 md:p-8 rounded-r-2xl" data-id="element-29">
            <h3 className="text-xl font-bold text-dark mb-3" data-id="element-30">
              La gran revelación:
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-31">
              No es falta de voluntad. Es un "ruido" en la comunicación de tus
              células. Tu ovario necesita una señal específica para funcionar, y
              esa señal depende de una proporción exacta que tu cuerpo ha dejado
              de producir.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}